import React, { useState } from 'react';
import { FaWhatsapp, FaFacebook, FaLinkedin, FaXTwitter, FaLink, FaCheck } from 'react-icons/fa6';

export default function ShareButtons({ title, url }) {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(url || '');
  const encodedTitle = encodeURIComponent(title || '');

  const shareLinks = [
    {
      name: 'WhatsApp',
      icon: <FaWhatsapp size={16} />,
      url: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
      className: 'btn-success',
    },
    {
      name: 'Facebook',
      icon: <FaFacebook size={16} />,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      className: 'btn-primary',
      bgStyle: { backgroundColor: '#1877F2' },
    },
    {
      name: 'LinkedIn',
      icon: <FaLinkedin size={16} />,
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      className: 'btn-primary',
      bgStyle: { backgroundColor: '#0A66C2' },
    },
    {
      name: 'X (Twitter)',
      icon: <FaXTwitter size={16} />,
      url: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      className: 'btn-dark',
    },
  ];

  const handleCopy = () => {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    }
  };

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <span className="text-muted small fw-semibold me-1">Compartilhe:</span>
      {shareLinks.map((item) => (
        <a
          key={item.name}
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          title={`Compartilhar no ${item.name}`}
          className="btn btn-sm rounded-circle d-inline-flex align-items-center justify-content-center text-white border-0 shadow-sm"
          style={{ width: 34, height: 34, ...(item.bgStyle || {}) }}
        >
          {item.icon}
        </a>
      ))}
      <button
        type="button"
        onClick={handleCopy}
        title="Copiar link do artigo"
        className={`btn btn-sm rounded-pill px-3 d-inline-flex align-items-center gap-1 border shadow-sm ${
          copied ? 'btn-success text-white' : 'btn-light text-secondary'
        }`}
      >
        {copied ? <FaCheck size={12} /> : <FaLink size={12} />}
        <span className="small">{copied ? 'Copiado!' : 'Copiar'}</span>
      </button>
    </div>
  );
}
